<template>
<div class="MStepThree">
    <div class="content_warp">
        <div class="type_box">
            <div class="row_box">
                <p class="title_text">激励股份比例<img @click="tipsClick('激励股份比例', textOne)" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field @input="checkTotalrate" v-model="formParams.totalrate" type="number" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">激励股份总股数</p>
                <van-field v-model="formParams.totalsicount" type="number" placeholder="自动生成" disabled><template #button><span>万股</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">首次激励股份比例<img @click="tipsClick('首次激励股份比例', textTwo)" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field @input="checkFirstrate" v-model="formParams.firstrate" type="number" placeholder="请输入"><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">首次激励股份数量</p>
                <van-field v-model="formParams.firstsicount" type="number" placeholder="自动生成" disabled><template #button><span>万股</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">预留股份比例<img @click="tipsClick('预留股份比例', textThree)" :src="require('@/common/images/gujingimgs/icon_tip2.png')" alt=""></p>
                <van-field @input="checkSurrate" v-model="formParams.surrate" type="number" placeholder="请输入" disabled><template #button><span>%</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">预留激励股份数量</p>
                <van-field v-model="formParams.sursicount" type="number" placeholder="自动生成" disabled><template #button><span>万股</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">目前公司估值</p>
                <van-field v-model="formParams.evmoney" type="number" placeholder="请输入" maxlength="8"><template #button><span>万元</span></template></van-field>
            </div>
            <div class="row_box">
                <p class="title_text">验证码</p>
                <van-field v-model="formParams.usercode" maxlength="4" placeholder="请输入验证码"><template #button><img @click="getAuthCode" class="auth_code_img" :src="authCodeImg === '' ? require('@/common/images/gujingimgs/bg1.png') : authCodeImg" alt=""></template></van-field>
            </div>
        </div>
    </div>
    <div class="btn_box">
        <div @click="upStep" class="up_btn">上一步</div>
        <div @click="createReport" class="next_btn">生成报告</div>
    </div>
</div>
</template>

<script>
import {createCode} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import {Toast} from 'vant'
export default {
    name: 'MStepThree',
    props: ['formParams', 'stepValue'],
    data() {
        return {
            textOne: '在实施股权激励前，通常需规划好公司用于股权激励的股份总量，包含首期授予以及未来预留的总量；根据一般经验，公司用于股权激励的股权总量不高于30%,10~20%为常见范围。<br/>激励股份比例=激励股份总股数÷公司总股本',
            textTwo: '首次激励股份比例=首期激励股份数量÷公司总股本',
            textThree: '预留股份比例=预留股份数量÷公司总股本',
            reg: /^[0-9]+\.{0,1}[0-9]{0,2}$/,
            authCodeImg: '' // 验证码图片
        }
    },
    mounted() {},
    methods: {
        // 获取验证码
        getAuthCode() {
            this.setLoading(true)
            let params = {}
            createCode({
                data: Object.assign({}, params),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.authCodeImg = data.result.base64
                    this.formParams.codeEncryption = data.result.codeEncryption
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 显示对应提示弹窗 及标题和内容
        tipsClick(tit, des) {
            this.$emit('setTipsPopInfo', tit, des)
        },
        // 验证输入的激励股份比例是否有效
        checkTotalrate() {
            if (!this.reg.test(this.formParams.totalrate) && this.formParams.totalrate.length > 0) {
                Toast('激励股份比例最多两位小数')
                return
            } else if (this.formParams.totalrate > 100) {
                Toast('激励股份比例不能超过100%')
                return
            } else {
                let allMoney = this.formParams.regcapital * 10000,
                    proportion = this.formParams.totalrate * 10000
                // 增资扩股情况下 股权激励股份总数 = (注册资本*激励股份比例) / (1-激励股份比例)
                if (this.formParams.sharesource == 1) {
                    if (this.formParams.totalrate == 100) {
                        this.formParams.totalsicount = (((allMoney * this.formParams.totalrate)).toFixed(0) / 10000).toFixed(2)
                    } else {
                        this.formParams.totalsicount = (((allMoney * this.formParams.totalrate) / (100 - this.formParams.totalrate)).toFixed(0) / 10000).toFixed(2)
                    }
                } else {
                    this.formParams.totalsicount =  (((allMoney * proportion) / 1000000).toFixed(0) / 10000).toFixed(2)
                }
                this.checkFirstrate()
                // 计算预留股份比例
                if (this.reg.test(this.formParams.totalrate) && this.reg.test(this.formParams.firstrate)) {
                    this.formParams.surrate = this.formParams.totalrate - this.formParams.firstrate
                }
            }
        },
        // 验证输入的首次激励股份比例是否有效
        checkFirstrate() {
            if (!this.reg.test(this.formParams.firstrate) && this.formParams.firstrate.length > 0) {
                Toast('首次激励股份比例最多两位小数')
                return
            } else if (parseFloat(this.formParams.firstrate) > parseFloat(this.formParams.totalrate)) {
                Toast('首次激励股份比例不能大于激励股份比例')
                return
            } else {
                let allMoney = this.formParams.regcapital * 10000,
                    proportion = this.formParams.firstrate * 10000
                // this.formParams.firstsicount =  ((allMoney * proportion) / 1000000).toFixed(0)
                // 增值扩容
                if (this.formParams.sharesource == 1) {
                    // 首次激励股份数量=新注册资本*首次激励股份比例
                    // 新注册资本=激励股份总股数 / 激励股份比例
                    if (this.formParams.totalsicount > 0) {
                        let zgb = this.transformationgu(this.formParams.totalsicount) / (this.formParams.totalrate / 100)
                        this.formParams.firstsicount =  ((zgb * (this.formParams.firstrate / 100)).toFixed(0) / 10000).toFixed(2)
                    } else {
                        this.formParams.firstsicount = ''
                    }
                } else {
                    this.formParams.firstsicount =  (((allMoney * proportion) / 1000000).toFixed(0) / 10000).toFixed(2)
                }
                // 计算预留激励股份数量
                this.onkeyupSurrate()
                // 计算预留股份比例
                if (this.reg.test(this.formParams.totalrate) && this.reg.test(this.formParams.firstrate)) {
                    this.formParams.surrate = this.formParams.totalrate - this.formParams.firstrate
                }
            }
        },
        // 计算预留激励股份数量 预留激励股份数量 = 激励股份总股数 - 首次激励股份数量
        onkeyupSurrate() {
            if (this.formParams.totalsicount && this.formParams.firstsicount) {
                this.formParams.sursicount = ((this.transformationgu(this.formParams.totalsicount) - this.transformationgu(this.formParams.firstsicount)) / 10000).toFixed(2)
            }
        },
        // 转换成万股
        transformation(nums) {
            return nums / 10000
        },
        // 转换成股
        transformationgu(nums) {
            return nums * 10000
        },
        // 验证输入的预留股份比例是否有效
        checkSurrate() {
            if (!this.reg.test(this.formParams.surrate) && this.formParams.surrate.length > 0) {
                Toast('预留股份比例最多两位小数')
                return
            } else if (this.formParams.surrate > 100) {
                Toast('预留股份比例不能超过100%')
                return
            } else {
                let allMoney = this.formParams.regcapital * 10000,
                    proportion = this.formParams.surrate * 10000
                this.formParams.sursicount =  ((allMoney * proportion) / 1000000).toFixed(0)
            }
        },
        // 上一步
        upStep() {
            this.$emit('setStepValue', 1)
        },
        // 生成报告
        createReport() {
            if (this.formParams.totalrate.length === 0) {
                Toast('激励股份比例不能为空')
                return
            }
            if (!this.reg.test(this.formParams.totalrate) && this.formParams.totalrate.length > 0) {
                Toast('激励股份比例最多两位小数')
                return
            }
            if (this.formParams.totalrate > 100) {
                Toast('激励股份比例不能超过100%')
                return
            }
            if (this.formParams.firstrate.length === 0) {
                Toast('首次激励股份比例不能为空')
                return
            }
            if (!this.reg.test(this.formParams.firstrate) && this.formParams.firstrate.length > 0) {
                Toast('首次激励股份比例最多两位小数')
                return
            }
            if (parseFloat(this.formParams.firstrate) > parseFloat(this.formParams.totalrate)) {
                Toast('首次激励股份比例不能大于激励股份比例')
                return
            }
            if (this.formParams.firstrate > 100) {
                Toast('首次激励股份比例不能超过100%')
                return
            }
            if (this.formParams.surrate.length === 0) {
                Toast('预留股份比例不能为空')
                return
            }
            if (!this.reg.test(this.formParams.surrate) && this.formParams.surrate.length > 0) {
                Toast('预留股份比例最多两位小数')
                return
            }
            if (this.formParams.surrate > 100) {
                Toast('预留股份比例不能超过100%')
                return
            }
            if (this.formParams.evmoney.length === 0) {
                Toast('目前公司估值不能为空')
                return
            }
            if (this.formParams.evmoney < 1 || this.formParams.evmoney > 10000000) {
                Toast('公司估值在 1 - 10000000 之间')
                return
            }
            if (!this.reg.test(this.formParams.evmoney)) {
                Toast('请填写正确的目前公司估值(两位小数内的整数)')
                return
            }
            if (this.formParams.usercode.length === 0) {
                Toast('请填写验证码')
                return
            }
            // console.log(this.formParams)
            this.$emit('GenerateReports')

        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        stepValue(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                // console.log(this.stepValue)
                if (this.stepValue === 2) {
                    this.getAuthCode()
                }
            })
        }
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.MStepThree {
    padding-bottom: 0.8rem;
    .content_warp {
        background-color: #fff;
        padding: 0.32rem;
        padding-top: 0.02rem;
        .type_box {
            .row_box {
                border-bottom: 0.01rem solid #E5E5E5;
                padding-top: 0.3rem;
                padding-bottom: 0.12rem;
                .title_text {
                    color: #333;
                    font-size: 0.32rem;
                    line-height: 0.46rem;
                    padding-bottom: 0.08rem;
                    display: flex;
                    align-items: center;
                    &>img {
                        margin-left: 0.2rem;
                        width: 0.22rem;
                        height: 0.22rem;
                    }
                }
                .van-cell{
                    padding: 0.2rem 0;
                    font-size: 0.32rem;
                }
            }
            .row_box:nth-last-of-type(1){
                border-bottom: none;
                padding-bottom: 0;
                .van-cell{
                    padding-bottom: 0;
                }
            }
        }
    }
    .btn_box {
        position: fixed;
        bottom: 0;
        left: 0;
        display: flex;
        width: 100vw;
        &>div {
            width: 50vw;
            height: 0.8rem;
            line-height: 0.8rem;
            text-align: center;
            font-size: 0.32rem;
            background-color: #E5E5E5;
            color: #666;
        }
        .next_btn {
            background-color: #409EFF;
            color: #fff;
        }
    }
}
</style>